import script from "./BaseToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseToggle.vue?vue&type=script&setup=true&lang=ts"

import "./BaseToggle.vue?vue&type=style&index=0&id=409988d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409988d6"]])

export default __exports__